import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { CompiereProcessService } from '@compiere-ws/services/compiere-process/compiere-process.service';
import { ProcessInProgressService } from '@compiere-ws/services/process-in-progress/process-in-progress.service';
import { SocketService } from '@compiere-ws/services/socket/socket.service';
import { ButtonUiComponent } from '@iupics-components/standard/fields/button-ui/button-ui.component';
import { DataStoreService } from '@iupics-manager/managers/data-store/data-store.service';
import { MessageManagerService } from '@iupics-manager/managers/message/message-manager.service';
import { SecurityManagerService } from '@iupics-manager/managers/security-manager/security-manager.service';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { WindowFactoryService } from '@iupics-manager/managers/ui-creator/window-factory/window-factory.service';
import { IupicsMessage } from '@iupics-manager/models/iupics-message';
import { TranslateService } from '@ngx-translate/core';
import { ProcessUiComponent } from '../process-ui/process-ui.component';
import { SpecificWindowUiComponent } from '../specific-window-ui/specific-window-ui.component';

@Component({
  selector: 'iu-payment-selection-window-ui',
  templateUrl: './payment-selection-window-ui.component.html',
  styleUrls: ['./payment-selection-window-ui.component.scss']
})
export class PaymentSelectionWindowUiComponent extends SpecificWindowUiComponent implements OnInit {
  SumSelectedRows = 0;
  processUiComponent: ProcessUiComponent;
  ButtonUiComponent: ButtonUiComponent;
  constructor(
    windowFactory: WindowFactoryService,
    resolver: ComponentFactoryResolver,
    uiCreator: UICreatorService,
    store: DataStoreService,
    processService: CompiereProcessService,
    protected translateService: TranslateService,
    private messageManager: MessageManagerService,
    socketService: SocketService,
    connectorService: SecurityManagerService,
    progressService: ProcessInProgressService
  ) {
    super(
      windowFactory,
      resolver,
      uiCreator,
      store,
      processService,
      socketService,
      connectorService,
      progressService,
      translateService
    );
    this.isModal = false;
  }
  ngOnInit() {
    super.ngOnInit();
  }

  notifyFromRowSelected(rowSelected: any) {
    this.SumSelectedRows = 0;
    if (this.dataStore.data.selections[0].selection.length > 0) {
      for (let i = 0; i < this.dataStore.data.selections[0].selection.length; i++) {
        this.SumSelectedRows += parseFloat(this.dataStore.data.selections[0].selection[i].AmountPay);
      }
      this.dataStore.data.Selected = this.SumSelectedRows;
      this.dataStore.data.Remaining = this.dataStore.data.CurrentBalance - this.SumSelectedRows;
    } else {
      this.dataStore.data.Selected = 0;
      this.dataStore.data.Remaining = 0;
    }
    this.setDataContainersValueWithChangedStore();
  }

  checkBeforeProcessing() {
    if (this.gridViews[0].GridTabInfinityScrollUiComponent.agGrid.api.getSelectedRows().length === 0) {
      this.messageManager.newMessage(
        new IupicsMessage(this.translateService.instant('specificWindow.paymentSelection.rowSelected'), 'error')
      );
    } else {
      return true;
    }
  }
}
